import { withRouter } from 'react-router-dom';
import { Component } from 'preact';

@withRouter
export default class ScrollToTop extends Component {

	componentDidUpdate(prevProps) {
		const lastUri = prevProps.location.pathname;
		const newUri = this.props.location.pathname;
		if (newUri !== lastUri) {
			window.scrollTo(0, 0);
		}
	}

	/**
	 * @see https://github.com/developit/preact/issues/1098
	 */
	render({ children }) {
		return children[0];
	}
}



// WEBPACK FOOTER //
// ./components/ScrollToTop.js